import React, { Component } from "react";
import PropTypes from "prop-types";
import { settleInvoice } from "../api";
import { List, Map } from "immutable";
import moment from "moment";
import CountryCodeSelect from '../request/countryCodeSelect';

import "./Passengers.css";

class SettleInvoiceEditor extends Component {
  constructor() {
    super();
    this.state = {
      settleInvoice: new Map()
        .set("issuer", "")
        .set("schemeCode", "")
        .set("countryCode", "")
        .set("postalCode", "")
        .set("city", "")
        .set("street1", "")
        .set("street2", "")
        .set("cardHolderName", "")
        .set("number", "")
        .set("effective", "")
        .set("expiry", "")
        .set("securityCode", ""),
      dirtyTracker: new Map()
        .set("issuer", false)
        .set("schemeCode", false)
        .set("countryCode", false)
        .set("postalCode", false)
        .set("city", false)
        .set("street1", false)
        .set("street2", false)
        .set("cardHolderName", false)
        .set("number", false)
        .set("effective", false)
        .set("expiry", false)
        .set("securityCode", false),
      showErrors: false
    };
  }

  setDirty = evt => {
    const name = evt.target.name;
    this.setState({
      dirtyTracker: this.state.dirtyTracker.set(name, true)
    });
  };

  handleUserInput = evt => {
    const name = evt.target.name;
    const value = evt.target.value;

    if (name === "schemeCode") {
      let issuer = "";
      if (value === "VI" || value === "VD") {
        issuer = "VISA";
      } else if (value === "CA" || value === "MD") {
        issuer = "MASTER_CARD";
      } else if (value === "DC") {
        issuer = "DINERS_CLUB";
      } else if (value === "AX") {
        issuer = "AMERICAN_EXPRESS";
      }
      if (issuer !== "") {
        this.setState({
          dirtyTracker: this.state.dirtyTracker.set(name, true),
          settleInvoice: this.state.settleInvoice.set(name, value).set("issuer", issuer)
        });
      } else {
        this.setState({ showErrors: true });
      }
    } else {
      this.setState({
        dirtyTracker: this.state.dirtyTracker.set(name, true),
        settleInvoice: this.state.settleInvoice.set(name, value)
      });
    }
  };

  submitRequest = () => {
    // validate

    // showErrors if need be
    console.log(JSON.stringify(this.state.settleInvoice));

    let request = new Map()
      .set(
        "payWith",
        new Map()
          .set("isA", "CardInformation")
          .set("cardScheme", Map.of("issuer", this.state.settleInvoice.get("issuer"), "schemeCode", this.state.settleInvoice.get("schemeCode")))
          .set(
            "billingAddress",
            Map.of(
              "countryCode",
              this.state.settleInvoice.get("countryCode"),
              "postalCode",
              this.state.settleInvoice.get("postalCode"),
              "city",
              this.state.settleInvoice.get("city"),
              "street",
              this.state.settleInvoice.get("street2") !== ""
                ? List.of(this.state.settleInvoice.get("street1"), this.state.settleInvoice.get("street2"))
                : List.of(this.state.settleInvoice.get("street1"))
            )
          )
          .set("cardHolderName", this.state.settleInvoice.get("cardHolderName"))
          .set("number", this.state.settleInvoice.get("number"))
          .set("effective", this.state.settleInvoice.get("effective"))
          .set("expiry", moment(this.state.settleInvoice.get("expiry"), "MMYY").format("YYYY-MM"))
          .set("securityCode", this.state.settleInvoice.get("securityCode"))
      )
      .set("company", this.props.company)
      .set("paymentInstruction", this.props.paymentInstructions);

    // console.log(JSON.stringify(request));
    this.props.setProcessingPayment(true);

    settleInvoice(request)
      // .then(
      //   response =>
      //     new Promise(resolve => {
      //       setTimeout(() => {
      //         resolve(response);
      //       }, 5000);
      //     })
      // )
      .then((settleInvoiceResponse = Map()) => {
        let acceptedOrders = settleInvoiceResponse
          .get("result")
          .reduce(
            (map, result) =>
              result.has("orderConfirmation") ? map.set(result.get("invoice"), result.get("orderConfirmation")) : map.set("errors", result.get("description", "There was some issues with payment.")),
            new Map()
          );
        let newList = this.props.bookingConfirmations;

        // console.log(acceptedOrders.toString());

        this.props.bookingConfirmations.forEach((v, k) => {
          console.log(v.getIn(["orderConfirmation", "invoice", "invoiceNumber"]));

          if (acceptedOrders.has(v.getIn(["orderConfirmation", "invoice", "invoiceNumber"]))) {
            newList = newList.set(
              k,
              Map.of(
                "orderConfirmation",
                acceptedOrders.get(v.getIn(["orderConfirmation", "invoice", "invoiceNumber"])),
                "furtherPaymentRequired",
                false
              )
            );
          }
        });
        this.props.updateBookingConfirmation(newList);
        if (acceptedOrders.has("errors")) {
          this.props.setPaymentError(acceptedOrders.get("errors"));
        }
      })
      .catch(settleInvoiceError => {
        console.warn(settleInvoiceError);
        this.props.setPaymentError("There was an issue with sending the payment. Please try again.");
      });
  };

  render() {
    const { settleInvoice, dirtyTracker, showErrors } = this.state;
    return (
      <section id="settleInvoice" className="book-section">
        <div className="col-sm-push-3 col-sm-18">
          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="schemeCode" value="Card: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <select
                className="combobox"
                id="schemeCode"
                name="schemeCode"
                value={settleInvoice.get("schemeCode")}
                onBlur={this.setDirty}
                onChange={this.handleUserInput}
              >
                <option value="" disabled>
                  - Card -
                </option>
                <option value="VI">Visa Personal/Corporate</option>
                <option value="VD">Visa Delta/Debit</option>
                <option value="CA">MasterCard</option>
                <option value="MD">MasterCard Debit</option>
                <option value="DC">Diners Club</option>
                <option value="AX">American Express</option>
              </select>
              <ValidationMessage
                message="Select a card"
                condition={(showErrors || dirtyTracker.get("schemeCode")) && settleInvoice.get("schemeCode") === ""}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="number" value="Card Number: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <input
                placeholder="Card Number"
                id="number"
                type="text"
                name="number"
                value={settleInvoice.get("number")}
                onBlur={this.setDirty}
                onChange={this.handleUserInput}
              />
              <ValidationMessage
                message="Card number must be 16 numbers long."
                condition={
                  (showErrors || dirtyTracker.get("number")) && settleInvoice.get("number") !== "" && settleInvoice.get("number").length !== 16
                }
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="securityCode" value="Security Code: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <input
                placeholder="Security Code"
                id="securityCode"
                type="text"
                name="securityCode"
                value={settleInvoice.get("securityCode")}
                onBlur={this.setDirty}
                onChange={this.handleUserInput}
              />
              <ValidationMessage
                message="Enter a valid security code/CVV"
                condition={(showErrors || dirtyTracker.get("securityCode")) && settleInvoice.get("securityCode") === ""}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="expiry" value="Expiry: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <div className="col-xs-6 no-padding-left">
                <input
                  placeholder="MMYY"
                  id="expiry"
                  type="text"
                  name="expiry"
                  value={settleInvoice.get("expiry")}
                  onBlur={this.setDirty}
                  onChange={this.handleUserInput}
                  pattern="0[1-9][2-3][0-9]|1[0-2][2-3][0-9]"
                />
              </div>
              <div className="col-xs-24 no-padding-left no-padding-right">
                <ValidationMessage
                  message="Enter a valid expiry date (format MMYY)"
                  condition={(showErrors || dirtyTracker.get("expiry")) && settleInvoice.get("expiry") === ""}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="cardHolderName" value="Cardholder Name: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <input
                placeholder="Cardholder Name"
                id="cardHolderName"
                type="text"
                name="cardHolderName"
                value={settleInvoice.get("cardHolderName")}
                onBlur={this.setDirty}
                onChange={this.handleUserInput}
              />
              <ValidationMessage
                message="Enter a name"
                condition={(showErrors || dirtyTracker.get("cardHolderName")) && settleInvoice.get("cardHolderName") === ""}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="countryCode" value="Country Code: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <CountryCodeSelect style={{width: '100%'}} value={settleInvoice.get("countryCode")} onChange={( v )=> this.handleUserInput({target:{name:'countryCode', value: v}})} onBlur={( v )=> this.setDirty({target:{name:'countryCode', value: v}})} />
              <ValidationMessage
                message="Enter a country code"
                condition={(showErrors || dirtyTracker.get("countryCode")) && settleInvoice.get("countryCode") === ""}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="postalCode" value="Postal Code: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <input
                placeholder="Postal Code"
                id="postalCode"
                type="text"
                name="postalCode"
                value={settleInvoice.get("postalCode")}
                onBlur={this.setDirty}
                onChange={this.handleUserInput}
              />
              <ValidationMessage
                message="Enter a postal code"
                condition={(showErrors || dirtyTracker.get("postalCode")) && settleInvoice.get("postalCode") === ""}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="city" value="City: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <input
                placeholder="City"
                id="city"
                type="text"
                name="city"
                value={settleInvoice.get("city")}
                onBlur={this.setDirty}
                onChange={this.handleUserInput}
              />
              <ValidationMessage message="Enter a city" condition={(showErrors || dirtyTracker.get("city")) && settleInvoice.get("city") === ""} />
            </div>
          </div>

          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="street1" value="Street #1: " required="true" />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <input
                placeholder="Street #1"
                id="street1"
                type="text"
                name="street1"
                value={settleInvoice.get("street1")}
                onBlur={this.setDirty}
                onChange={this.handleUserInput}
              />
              <ValidationMessage
                message="Enter a street address"
                condition={(showErrors || dirtyTracker.get("street1")) && settleInvoice.get("street1") === ""}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-sm-push-2 col-sm-5">
              <Label name="street2" value="Street #2: " />
            </div>
            <div className="col-sm-push-2 col-sm-14 passenger-input">
              <input
                placeholder="Street #2"
                id="street2"
                type="text"
                name="street2"
                value={settleInvoice.get("street2")}
                onBlur={this.setDirty}
                onChange={this.handleUserInput}
              />
            </div>
          </div>

          {/* <div className="row">
              <div className="col-sm-push-2 col-sm-5">
                <Label name="email" value="Email: " required="true" />
              </div>
              <div className="col-sm-push-2 col-sm-14 passenger-input">
                <input
                  placeholder="Email"
                  id="email"
                  type="text"
                  name="email"
                  value={settleInvoice.get("email")}
                  onBlur={this.setDirty}
                  onChange={this.handleUserInput}
                />
                <ValidationMessage
                  message="Enter a valid email address"
                  condition={(showErrors || dirtyTracker.get("dirty_email")) && !validateEmailAddress(settleInvoice.get("email"))}
                />
              </div>
            </div>
            <div className="row">
              <div className="col-sm-push-2 col-sm-5">
                <Label name="phoneNumber" value="Phone Number: " required="true" />
              </div>
              <div className="col-sm-push-2 col-sm-14 passenger-input">
                <input
                  placeholder="Phone Number"
                  id="phonenumber"
                  type="text"
                  name="phoneNumber"
                  value={settleInvoice.get("phoneNumber")}
                  onBlur={this.setDirty}
                  onChange={this.handleUserInput}
                  pattern="[+]{0,1}[0-9]{9,}"
                />
                <ValidationMessage
                  message="Enter a valid phone number"
                  condition={(showErrors || dirtyTracker.get("dirty_phoneNumber")) && !validatePhoneNumber(settleInvoice.get("phoneNumber"))}
                />
              </div>
            </div> */}
          <div className="row">
            <div className="col-sm-push-7 col-sm-14 passenger-input">
              <div className="clearfix" style={{ display: "flex" }}>
                <a className="btn btn-primary min-width-140" style={{ margin: "auto" }} onClick={this.submitRequest}>
                  Pay
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const Label = ({ name, value, required = false }) => {
  return (
    <div className="col-wrapper-va">
      <div className="v-align">
        <label className="label-align" htmlFor={name}>
          {required ? <span className="red">* </span> : null}
          {value}
        </label>
      </div>
    </div>
  );
};

const ValidationMessage = ({ message, condition }) => (condition ? <div className="validation-message alert-danger"> {message} </div> : null);

SettleInvoiceEditor.propTypes = {
  company: PropTypes.string.isRequired,
  paymentInstructions: PropTypes.object.isRequired,
  updateBookingConfirmation: PropTypes.func.isRequired
};

export default SettleInvoiceEditor;

// export const validateEmailAddress = email => {
//   return new RegExp(
//     /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
//   ).test(email);
// };
// export const validatePhoneNumber = phoneNumber => {
//   return new RegExp(/[+]{0,1}[0-9]{9,}/).test(phoneNumber);
// };



// WEBPACK FOOTER //
// ./src/ndc/booking/SettleInvoiceEditor.js